<template>
  <div>
    <template v-if="custom_value === undefined">
      <v-text-field :value="value" @input="$emit('input', $event)" @keyup.enter="enter" v-bind="$attrs">
      </v-text-field>
    </template>
    <template v-else>
      <v-text-field v-model="customVal" @input="$emit('input', $event)" @keyup.enter="enter" v-bind="$attrs">
        <template v-slot:append-outer>{{customVal}}</template>
      </v-text-field>
    </template>
  </div>
</template>

<script>
export default {
    name: "DoneTypingSearch",
    components: {},
    props: ['value', 'custom_value'],
    data: () => ({
      delay: null,
      customVal: null,
    }),
    watch:{
      value(v) {
        this.doneTyping(v);
      },
      customVal(v) {
        this.doneTyping(v);
      },
    },
    mounted(){
      if(this.custom_value !== undefined){
        this.customVal = this.custom_value
      }
    },
    methods: {
      doneTyping(event){
        console.log('done typing')
        clearTimeout(this.delay)
        this.delay = setTimeout(() => {
          this.$emit('done', event)
        }, 800)
      },
      enter(event){
        this.$emit('enter', event.target.value);
      },
      regexQuery(search){
        search = search.replace('-', '');
        // Uhm i can explain i swear....
        //For editing put spaces before and after every | (or) character( CTRL + F helps )  REMOVE THE SPACES WHEN DONE
        //First group checks if value looks like  WA-yoursearch-digits
        // Second group checks if value looks like WA-digits-yoursearch
        // Third group is just your plain value on its own
        // Fourth group checks anything before and after your search string. Similar to LIKE %%
        // This is a fuzzy search method normally used for POSTGRES regex query, note every query you use this in should not run the query if the search is less than 3 digits or doesn't contain a number at all.
        // This is just a rule i follow to prevent overly large data sets from coming in.
        return `([A-Z]{2}-([0-9]{1,})*${search}([0-9]{1,})*)|[A-Z]{2}-([0-9]{1,})*-([0-9]{1,})*${search}([0-9]{1,})*|(${search})|((.*?)${search}(.)*)`
      }
    }
}
</script>

<style scoped>

</style>
